import { getPath } from '@witkac/utils/getPath';
import { setPath } from '@witkac/utils/setPath';

/**
 * Wylicza dane podsumowania tabeli
 *
 * @param {any[]} items
 * @param {any[]} columns
 * @param {Record<string, any>} [extras={}]
 * @return
 */
export function calculateFootData(items: any[], columns: any[], extras: Record<string, any> = {}) {
  const footData = {};
  const sumRowColumns = columns.filter(column => column.isSumRow);
  sumRowColumns
    .filter(column => column.calcSumRow !== false && !column.staticSumRow)
    .forEach(column => {
      const sum = items
        .map((rowItem, index, allItems) => {
          if (column.sumRowCalc) {
            return new Function('rowItem', 'index', 'allItems', column.sumRowCalc)(rowItem, index, allItems);
          }
          return getPath(rowItem, column.name);
        })
        .filter(value => !!value)
        .reduce((all, value) => all + parseFloat(value), 0);
      setPath(footData, sum, column.name);
    });
  sumRowColumns
    .filter(column => !!column.staticSumRow)
    .forEach(column => setPath(footData, column.staticSumRow, column.name));
  return { ...footData, ...extras };
}
